import axios from 'axios';
import store from '@/store'
import { userAuth } from '@/api';
import { v4 as uuidv4 } from 'uuid';

const smrApiBaseURL = '/routenplaner/api';
export const smrApi = axios.create(
  {
    baseURL: smrApiBaseURL,
  }
);

export const tokenApi = axios.create(
  {
    baseURL: '/routenplaner/auth',
  }
);

export const  authApi = axios.create(
  {
    baseURL: smrApiBaseURL,
  }
)

// add unique uuid to every request
smrApi.interceptors.request.use(
  async config => {
    config.baseURL = smrApiBaseURL
    config.headers['X-OEAMTC-RequestID'] = uuidv4()
    return config;
  },
  error => {
    Promise.reject(error)
});

authApi.interceptors.request.use(
    async config => {
      config.baseURL = smrApiBaseURL
      if(store.getters.sessionData && store.getters.sessionData.access_token) {
        config.headers['Authorization'] = `Bearer ${store.getters.sessionData.access_token}`
      }
      // config.headers['x-forwarded-auth'] = `session:${store.getters.user.sessionToken}`
      return config;
    },
    error => {
      Promise.reject(error)
  });
  
  // Response interceptor for API calls
  authApi.interceptors.response.use((response) => {
    return response
  }, async function (error) {
    const originalRequest = error.config;
    if (error.response.status === 403 && !originalRequest._retry) {
      originalRequest._retry = true;
      const access_token = await refreshSessionData(store.getters.sessionData.refresh_token);            
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + access_token;
      return authApi(originalRequest);
    }
    return Promise.reject(error);
  });


  async function refreshSessionData(refreshToken) {
    try {
        const res = await userAuth.refreshUserSessionData(refreshToken)
        store.commit('setSessionData', res.data)
        return res.data.access_token
    } catch(error) {
        console.error(error)
        store.commit('setSessionData', false)
    }
  }